import { Capacitor } from '@capacitor/core';
import { CapacitorWechat } from '@capgo/capacitor-wechat';
import { toast } from 'react-toastify';
import IconToast from '../../components/NewToast';

// Scene constants
export const WechatScene = {
  CHAT: 0, // Share to chat
  MOMENTS: 1, // Share to Moments (timeline)
  FAVORITE: 2 // Share to Favorites
};

export const isWechatInstalled = async () => {
  try {
    const { installed } = await CapacitorWechat.isInstalled();
    return installed;
  } catch {
    return false;
  }
};

/**
 * Share a link to WeChat (native only via @capgo/capacitor-wechat)
 * @param {Object} options
 * @param {string} options.title - Share title
 * @param {string} options.description - Share description
 * @param {string} options.link - URL to share
 * @param {string} [options.thumbUrl] - Thumbnail image URL
 * @param {number} [options.scene=0] - 0: Chat, 1: Moments, 2: Favorite
 */
export const shareToWechat = async ({ intl, title, description, link, thumbUrl, scene = WechatScene.CHAT }) => {
  const platform = Capacitor.getPlatform();
  if (platform === 'web') {
    toast.error(IconToast('error', intl.formatMessage({ id: 'wechat-sharing-is-only-available-on-mobile-app' })), {
      className: 'new-toast'
    });
    return;
  }

  const installed = await isWechatInstalled();
  if (!installed) {
    toast.error(IconToast('error', intl.formatMessage({ id: 'wechat-not-installed' })), { className: 'new-toast' });
    return;
  }

  // Nothing to link to (e.g. 支票精靈 shares only its message): a link card with an
  // empty URL opens nothing, so the message goes as plain text instead.
  if (!link) {
    return CapacitorWechat.share({ scene, type: 'text', text: description || title });
  }

  return CapacitorWechat.share({
    scene,
    type: 'link',
    title,
    description,
    link,
    thumbUrl
  });
};
